export const SET_LOCATION = "SET_LOCATION"